<template>
  <v-app id="App">
    <template v-if="getLoadingScreen">
      <CoreLoadingScreen />
    </template>

    <template v-else>
      <template v-if="isLogged">
        <CoreAppBar />
        <CoreDrawer />
        <CoreView />
      </template>

      <template v-else>
        <router-view></router-view>
      </template>

      <Loading />
      <Alert />
    </template>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "App",

  components: {
    CoreAppBar: () => import("@/components/core/AppBar"),
    CoreDrawer: () => import("@/components/core/Drawer"),
    CoreView: () => import("@/components/core/View"),
    CoreLoadingScreen: () => import("@/components/core/LoadingScreen"),

    Loading: () => import("@/components/utils/Loading"),
    Alert: () => import("@/components/utils/Alert")
  },

  computed: {
    ...mapGetters("app", ["getLoadingScreen"]),
    ...mapGetters("auth", ["isLogged"])
  },

  created() {
    this.$analytics.app.name = "br.com.flyvendas.web";
    this.$analytics.app.logEvent("accessApp_flyVendasWeb");
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/app.scss";
</style>
